/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const StyledSelectSkeleton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

export const StyledLabelSkeleton = styled(Skeleton).attrs({
    variant: SkeletonVariant.TEXT,
})`
    width: 50%;
    ${theme.typography.body_small}
`;

export const StyledOptionSkeleton = styled(Skeleton).attrs({
    variant: SkeletonVariant.BLOCK,
})`
    width: 100%;
    height: 4.8rem;
`;
